/** 可克隆、可重放的 Mulberry32 随机状态；不保存闭包。 */
export class BattleRandom {
    /**
     * 创建实例并初始化所需的领域状态。
     * @param state 初始状态；默认值为 `Date.now() >>> 0`
     */
    constructor(public state: number = Date.now() >>> 0) {}

    /**
     * next：执行对应的领域操作。
     * @returns 本次操作的结果；具体取值由当前状态与分支决定。
     */
    next(): number {
        this.state = (this.state + 0x6d2b79f5) >>> 0;
        /**
         * value，供本模块相关规则使用。
         */
        let value = this.state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    }
}
